module.exports = __webpack_public_path__ + "static/media/LoyaltyScreen.90cab159.png";